<template>
	<div class="header">
		<a class="logo_a" href="//m.58.com">
			<div class="logo"></div>
		</a>
		<a class="changeCity" @click="changeCity">
			<span id="city">{{areaName}}</span>
		</a>
		<div class="my58" v-if="isLogin" onclick="document.location.href='//m.m.58.com/index/'"></div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['areaName', 'pagetypeLog', 'isLogin'])
	},
	methods: {
		changeCity() {
			if (location.hash.indexOf('expectation')) {
				window.clickLog &&
					window.clickLog(
						'from=jl_changecity_second' + this.pagetypeLog
					);
			} else {
				window.clickLog &&
					window.clickLog(
						'from=jl_changecity_first' + this.pagetypeLog
					);
			}
			location.href = '//m.58.com/city.html?from=click_city_new'; // 域名为简历的切换城市后返回首页
		}
	}
};
</script>

<style lang="scss" scoped>
.header {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 45px;
	padding: 0 !important;
	background: url(//img.58cdn.com.cn/m58/job/img/zp_head_new.png) no-repeat
		#ff5f1c;
	background-size: 320px auto;
	border-bottom: 0;
}
a.logo_a {
	display: block;
	float: left;
	width: 33px;
	height: 30px;
	margin-top: 5px;
	margin-left: 8px;
	-webkit-border-radius: 2px;
}
.header .logo {
	position: absolute;
	top: 12px;
	left: 5px;
	width: 27px;
	height: 22px;
	background: 0 0;
}
.header .my58 {
	float: right;
	width: 42px;
	height: 45px;
	background: url(//img.58cdn.com.cn/m58/job/img/my_logo.png) no-repeat
		#ff5f1c;
	background-size: 43px;
}
.changeCity {
	display: inline-block;
	height: 45px;
	line-height: 45px;
	font-size: 13px;
	color: #fff;
	float: left;
}
#city {
	position: relative;
}
#city:after {
	display: inline-block;
	border: 4px solid transparent;
	border-top-color: #fff;
	content: '';
	margin: 10px 0 0 4px;
}
</style>



// WEBPACK FOOTER //
// index.vue?6074a5b2